import { CurrencyCode } from '@buggy/shared'
import { useFetchUserStatusQuery } from '@/api/user-api'

const useCampaignVisible = (): boolean => {
  const { data: userStatus } = useFetchUserStatusQuery()
  return userStatus?.currentWorkspace.currencyCode === CurrencyCode.TWD
}

export default useCampaignVisible
